// import React, { useState } from 'react';
// import { 
//   Copy, Users, CircleDollarSign, Wallet, Send, Facebook, 
//   Twitter, MessageCircle, ExternalLink, Lock, Zap 
// } from 'lucide-react';
// //import Sidebar from "./component/peermatesidebar";
// import Navbar from "../../../src/components/Navbar";

// const ReferralDashboard = () => {
//   const referralLink = "https://peermate.ai/ref/haleem";
//   const couponCode = "FRONTEND30";
//   const [copiedLink, setCopiedLink] = useState(false);
//   const [copiedCoupon, setCopiedCoupon] = useState(false);

//   const handleCopy = (text, setter) => {
//     navigator.clipboard.writeText(text);
//     setter(true);
//     setTimeout(() => setter(false), 2000);
//   };

//   const referrals = [
//     { name: "Sandra Effiong", amount: "+₦50", date: "11/02/2026", status: "Signed Up", color: "bg-emerald-100 text-emerald-700" },
//     { name: "Sandra Effiong", amount: "+₦100", date: "11/02/2026", status: "Enrolled a course", color: "bg-blue-100 text-blue-700" },
//     { name: "Sandra Effiong", amount: "+₦150", date: "07/02/2026", status: "Group class", color: "bg-purple-100 text-purple-700" },
//     { name: "Sandra Effiong", amount: "+₦50", date: "11/02/2026", status: "Signed Up", color: "bg-emerald-100 text-emerald-700" },
//     { name: "Sandra Effiong", amount: "+₦50", date: "11/02/2026", status: "Signed Up", color: "bg-emerald-100 text-emerald-700" },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50 mt-20">
//       <Navbar />

//       <div className="flex flex-col md:flex-row">
        

//         <div className="flex-1 p-4 md:p-6 max-w-full md:max-w-4xl mx-auto space-y-6 font-sans text-slate-800">

//           {/* SECTION 1: Header */}
//           <div className='mt-15'>
//             <div className="flex items-center gap-2 mb-1">
//               <span className="text-xl">🎁</span>
//               <h1 className="text-xl font-bold">Referrals & Rewards</h1>
//             </div>
//             <p className="text-gray-500 text-sm">Invite Friends, Earn Rewards.</p>
//           </div>

//           {/* SECTION 2: Referral Link */}
//           <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm">
//             <h2 className="text-sm font-semibold mb-4 text-slate-700">Your Referral Link</h2>
//             <div className="flex flex-col sm:flex-row items-center border border-gray-200 rounded-lg overflow-hidden mb-4">
//               <input readOnly value={referralLink} className="flex-1 p-3 text-blue-500 bg-white text-sm outline-none w-full sm:w-auto" />
//               <button onClick={() => handleCopy(referralLink, setCopiedLink)} className="flex items-center gap-2 px-4 py-3 bg-gray-50 text-xs font-medium text-gray-600 hover:bg-gray-100 transition-colors w-full sm:w-auto justify-center mt-2 sm:mt-0">
//                 <Copy size={14} /> {copiedLink ? 'Copied!' : 'Copy Link'}
//               </button>
//             </div>
//             <div className="flex flex-col sm:flex-row justify-between items-center text-xs gap-2 sm:gap-0">
//               <p className="text-gray-400 italic">Earn rewards when friends sign up using your link</p>
//               <div className="flex gap-3 items-center">
//                 <MessageCircle className="text-emerald-400 cursor-pointer hover:opacity-80" size={18} fill="currentColor" />
//                 <div className="bg-black rounded-full p-1 cursor-pointer hover:opacity-80"><Twitter className="text-white" size={10} fill="currentColor" /></div>
//                 <Facebook className="text-blue-600 cursor-pointer hover:opacity-80" size={18} fill="currentColor" />
//                 <div className="bg-sky-400 rounded-full p-1 cursor-pointer hover:opacity-80"><Send className="text-white" size={10} fill="currentColor" /></div>
//               </div>
//             </div>
//           </div>

//           {/* SECTION 3: Referral Overview */}
//           <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm">
//             <h2 className="text-sm font-semibold mb-6 text-slate-700">Referral Overview</h2>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//               <StatCard icon={<Users size={16}/>} label="Total Referrals" value="0" unit="people" />
//               <StatCard icon={<CircleDollarSign size={16}/>} label="Total Earned" value="0" unit="naira" />
//               <StatCard icon={<Wallet size={16}/>} label="Balance Available" value="0" unit="naira" />
//             </div>
//           </div>

//           {/* SECTION 4: Recent Referrals Table */}
//           <div className="bg-white rounded-xl shadow-sm overflow-x-auto">
//             <div className="p-4 border-b border-gray-50 flex justify-between items-center">
//               <h2 className="text-sm font-semibold text-slate-700">Recent Referrals</h2>
//               <button className="text-xs text-slate-500 flex items-center gap-1 hover:underline">
//                 View All <ExternalLink size={12} />
//               </button>
//             </div>
//             <div className="overflow-x-auto">
//               <table className="w-full text-left text-sm min-w-[500px]">
//                 <thead className="bg-gray-50/50 text-gray-400 text-[10px] uppercase tracking-wider">
//                   <tr>
//                     <th className="px-6 py-3 font-medium">Name</th>
//                     <th className="px-6 py-3 font-medium">Reward</th>
//                     <th className="px-6 py-3 font-medium text-center">Date</th>
//                     <th className="px-6 py-3 font-medium text-right">Activity/Status</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-50">
//                   {referrals.map((ref, idx) => (
//                     <tr key={idx} className="hover:bg-gray-50/30 transition-colors">
//                       <td className="px-6 py-4 text-gray-700 font-medium">{ref.name}</td>
//                       <td className="px-6 py-4 text-gray-600 font-semibold">{ref.amount}</td>
//                       <td className="px-6 py-4 text-gray-400 text-center">{ref.date}</td>
//                       <td className="px-6 py-4 text-right">
//                         <span className={`px-3 py-1 rounded-full text-[10px] font-bold ${ref.color}`}>
//                           {ref.status}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* SECTION 5: Spend Your Rewards */}
//           <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm">
//             <h2 className="text-sm font-semibold text-slate-700">Spend Your Rewards</h2>
//             <p className="text-xs text-gray-400 mt-1 mb-4">Unblock courses or start your Free-Mate plan.</p>
//             <div className="flex flex-col sm:flex-row gap-4">
//               <button className="flex items-center gap-3 p-3 rounded-lg bg-white shadow-sm group w-full sm:w-auto justify-start">
//                 <div className="p-2 bg-orange-50 text-orange-400 rounded-md group-hover:bg-orange-100"><Lock size={16} /></div>
//                 <div className="text-left">
//                   <p className="text-xs font-bold text-gray-700 leading-tight">Unblock a Course</p>
//                   <p className="text-[10px] text-gray-400 font-bold">₦1,500</p>
//                 </div>
//               </button>
//               <button className="flex items-center gap-3 p-3 rounded-lg bg-white shadow-sm group w-full sm:w-auto justify-start">
//                 <div className="p-2 bg-blue-50 text-blue-400 rounded-md group-hover:bg-blue-100"><Zap size={16} /></div>
//                 <div className="text-left">
//                   <p className="text-xs font-bold text-gray-700 leading-tight">Start Free-Mate Plan</p>
//                   <p className="text-[10px] text-gray-400 font-bold">₦1,000</p>
//                 </div>
//               </button>
//             </div>
//           </div>

//           {/* SECTION 6: Coupons */}
//           <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm">
//             <h2 className="text-sm font-semibold text-slate-700">Coupons</h2>
//             <p className="text-xs text-gray-400 mt-1 mb-6">Use your coupons to unblock exclusive course discounts.</p>
//             <div className="bg-orange-50/30 p-4 md:p-6 rounded-xl mb-4">
//               <h3 className="text-xs font-bold text-gray-700 mb-4">Your Available Coupons</h3>
//               <div className="flex flex-col sm:flex-row items-center border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm">
//                 <div className="flex-1 p-3 text-xs">
//                   <span className="text-gray-500 font-medium">Coupon Code: </span>
//                   <span className="font-bold text-gray-800">{couponCode}</span>
//                 </div>
//                 <button onClick={() => handleCopy(couponCode, setCopiedCoupon)} className="flex items-center gap-2 px-4 py-3 bg-gray-50 text-[10px] font-medium text-gray-500 hover:bg-gray-100 w-full sm:w-auto justify-center mt-2 sm:mt-0">
//                   <Copy size={12} /> {copiedCoupon ? 'Copied!' : 'Copy Coupon Code'}
//                 </button>
//               </div>
//               <div className="mt-4 space-y-1">
//                 <p className="text-xs font-bold text-gray-600">Discount: 3% off</p>
//                 <p className="text-xs text-gray-500">Valid for: Front-End development course</p>
//                 <p className="text-xs text-gray-400 italic">Expires: April 30, 2026</p>
//               </div>
//             </div>
//             <p className="text-[10px] text-gray-400 italic">*Coupons can be applied during checkout.</p>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// const StatCard = ({ icon, label, value, unit }) => (
//   <div className="bg-blue-50/40 p-4 rounded-xl border border-blue-100/30">
//     <div className="flex items-center gap-2 text-slate-500 mb-2">
//       {icon} <span className="text-[10px] font-bold uppercase tracking-tight">{label}</span>
//     </div>
//     <div className="flex items-baseline gap-1">
//       <span className="text-xl font-bold">₦{value}</span>
//       <span className="text-[10px] text-gray-400 font-medium lowercase italic">{unit}</span>
//     </div>
//   </div>
// );

// export default ReferralDashboard;


import { Users } from "lucide-react";

export default function ReferralComingSoon() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-6">
      <div className="max-w-xl text-center">
        
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="p-4 rounded-full bg-gray-100">
            <Users className="w-10 h-10 text-gray-700" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
          Referral Program – Coming Soon
        </h1>

        {/* Description */}
        <p className="text-gray-600 leading-relaxed mb-4">
          We are building an exciting referral system that will allow you to invite 
          friends and earn rewards as they join and learn on our platform.
        </p>

        <p className="text-gray-600 leading-relaxed">
          This feature is currently under development and may take some time to 
          complete. Stay tuned as we prepare to launch a rewarding referral experience 
          for our community.
        </p>

        {/* Badge */}
        <div className="mt-6">
          <span className="inline-block px-4 py-2 text-sm font-medium bg-gray-100 text-gray-700 rounded-full">
            Feature in Development
          </span>
        </div>

      </div>
    </div>
  );
}